import * as React from 'react';
import { createPortal } from 'react-dom';
import { IconButton, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './NewbuildingChatPopup.css';

interface INewbuildingChatPopupProps {
  url?: string;
  onClose(): void;
}

export const NewbuildingChatPopup: React.FC<INewbuildingChatPopupProps> = ({ url, onClose }) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = React.useCallback(() => setIsLoading(false), []);

  const content = (
    <div className={styles['container']} data-testid="NewbuildingChatPopup">
      <span className={styles['close']}>
        <IconButton data-testid="NewbuildingChatCloseButton" icon={<IconActionClose16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      {url && <iframe className={styles['iframe']} src={url} onError={onLoad} onLoad={onLoad} />}
    </div>
  );

  // Рендерим в портал: position: fixed попапа должен считаться от вьюпорта. Иначе в плавающей шапке
  // (у неё transform) fixed привязывается к шапке, и попап уезжает за экран / обрезается overflow.
  return typeof document === 'undefined' ? null : createPortal(content, document.body);
};
